




















import Vue from "vue";
export default Vue.extend({
    props: {
        showDialog: { type: Boolean, required: true },
        loading: Boolean,
    },
    computed: {
        showRevertDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog");
            },
        },
    },
});
